import styled from '@emotion/styled';
import Icon from '@icon/Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Leave = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 24 24" {...rest}>
      <path
        d="M3 12.0396H13M3 12.0396L5.5 9M3 12.0396L5.5 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5.86667V5C10 4.44772 10.4477 4 11 4H20C20.5523 4 21 4.44772 21 5V19C21 19.5523 20.5523 20 20 20H11C10.4477 20 10 19.5523 10 19V18.1333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

export default Leave;
